import { utils, config } from "../../../../studentportal-sdk";

// Function to create a new course
export const courseCreation = async ({
  title,
  description,
  startDate,
  endDate,
}) => {
  try {
    const { data } = await utils
      .apiConnect()
      .post(config.domains.endpoints.postCourseApi, {
        title,
        description,
        startDate,
        endDate,
      });
    return {
      status: true,
      data: data.data,
      message: "",
    };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};
// export const createCourse = async (courseDetails) => {
//   try {
//     const response = await utils
//       .apiConnect()
//       .post(config.domains.endpoints.postCourseApi);

//     return {
//       status: true,
//       data: response.data, // Returning the created course data
//       message: "Course created successfully",
//     };
//   } catch (error) {
//     return {
//       status: false,
//       message: error?.response?.data?.message || error.message,
//       error: true,
//     };
//   }
// };

export const getAllCourse = async() => {
    try{
        const {data} = await utils.apiConnect().get(config.domains.endpoints.getAllCourseApi)
        return {
            status: true,
            data: data.data,
            message: data.message
        }
    }catch(error){
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}

export const addCourse = async(formdata) => {
    try{
        const {data} = await utils.apiConnect().post(config.domains.endpoints.postCourseApi, formdata)

        return {
            status: true,
            data: data.data,
            message: data.message
        }
    }catch(error){
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}


export const updateCourse = async(formdata) => {
    try{
        const {data} = await utils.apiConnect().put(config.domains.endpoints.updateCourseApi, formdata)

        return {
            status: true,
            data: data.data,
            message: data.message
        }
    }catch(error){
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}
export const getCourseById = async(id) => {
    try{
        const {data} = await utils.apiConnect().get(config.domains.endpoints.getSingleCourseApi+`?courseId=${id}`)
        return {
            status: true,
            data: data.data,
            message: data.message
        }
    }catch(error){
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}

export const deleteCourseById = async(id) => {
    try{
        const {data} = await utils.apiConnect().delete(config.domains.endpoints.deleteCourseApi+`?courseId=${id}`)
        return {
            status: true,
            data: data.data,
            message: data.message
        }
    }catch(error){
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}
